import { defineMessages } from 'react-intl';

const messages = defineMessages({
    resultsCountTotal: {
        id:'resultsCountTotal',
        defaultMessage: 'Showing {totalCount, number} {totalCount, plural, one {result} other {results}}',
        description: 'Label for total number of results.',
    },
});

export default messages;
